import useI18n from 'src/hooks/useI18n'

interface Props {
  appliedMinPrice: number;
  appliedMaxPrice: number;
  minPrice: number | undefined;
  maxPrice: number | undefined;
  handlesApply: (
    paramsTags: Record<string, string[]> | null,
    paramsProperties: Record<string, string[]> | null,
    paramsSort: string | null,
    paramsMinPrice: number | null,
    paramsMaxPrice: number | null
  ) => void;
}

const FilteredPrice = (props: Props) => {
  const { appliedMinPrice, appliedMaxPrice, minPrice, maxPrice, handlesApply } = props

  const translation = useI18n()
  const formatNumber = (value: number) => `${translation.filter.currency} ${value.toFixed(2).replace('.', ',')}`

  return (
    <>
      {(minPrice && maxPrice) && (appliedMinPrice || appliedMaxPrice) && (
          <div className="filtered-price filtered-type">
            <div className="filtered-item">
              <span>{`${formatNumber(appliedMinPrice || minPrice)} - ${formatNumber(appliedMaxPrice || maxPrice)}`}</span>
              <button aria-label={`Limpar filtro de preço: ${formatNumber(appliedMinPrice || minPrice)} - ${formatNumber(appliedMaxPrice || maxPrice)}`} className="filtered-items-button-clear" onClick={() => handlesApply(null, null, null, -1, -1)}></button>
            </div>
          </div>
      )}
    </>
  )
}

export default FilteredPrice
